import React, { Fragment } from "react";
import { CDBProgress, CDBBadge} from "cdbreact";
import { Layout } from "../Layout";
import { TemplateNav } from "../TemplateNav";
import Sidebar from "../Sidebar";

export const Progress = () => {
  return (
    <div className="d-flex w-100">
      <div style={{height:"100vh", overflow:"hidden initial"}}>
        <Sidebar/>
      </div>
      <Layout>
        <TemplateNav/>
    <div className="r-w">
      <div>
        <div style={{ margin: "20px 0", width: "100%" }}></div>
        <div className="blockcode">
          <div className="header">Rect Progress Default </div>
          <div className="description"></div>
          <div className="example2">
            <div>
              <CDBProgress value={69} text={`${69}%`}></CDBProgress>
            </div>
          </div>
        </div>
        <div className="blockcode">
          <div className="header">Rect Progress color variants </div>
          <div className="description"></div>
          <div className="example2">
            <div>
              <CDBProgress
                value={10}
                text={`${10}%`}
                colors="primary"
              ></CDBProgress>
            </div>
            <div>
              <CDBProgress
                value={20}
                text={`${20}%`}
                colors="secondary"
              ></CDBProgress>
            </div>
            <div>
              <CDBProgress
                value={70}
                text={`${70}%`}
                colors="success"
              ></CDBProgress>
            </div>
            <div>
              <CDBProgress
                value={40}
                text={`${40}%`}
                colors="danger"
              ></CDBProgress>
            </div>
            <div>
              <CDBProgress
                value={90}
                text={`${90}%`}
                colors="info"
              ></CDBProgress>
            </div>
            <div>
              <CDBProgress
                value={60}
                text={`${60}%`}
                colors="warning"
              ></CDBProgress>
            </div>
          </div>
        </div>
        <div className="blockcode">
          <div className="header">Fixed height</div>
          <div className="description"></div>
          <div className="example2">
            <div>
              <CDBProgress
                value={45}
                colors="dark"
                height={30}
                text={`${45}%`}
              ></CDBProgress>
            </div>
            <div>
              <CDBProgress
                value={60}
                colors="success"
                height={20}
                text={`${60}%`}
              ></CDBProgress>
            </div>
            <div>
              <CDBProgress
                value={80}
                colors="danger"
                height={40}
                text={`${80}%`}
              ></CDBProgress>
            </div>
          </div>
        </div>
      </div>
    </div>
      </Layout>
    </div>
  );
};
